/** A dark-terminal section card with a title, optional eyebrow + hint line. */
import type { ReactNode } from "react";

interface PanelProps {
  title: string;
  eyebrow?: string;
  hint?: string;
  /** An expandable explainer (e.g. <InfoCallout>) rendered under the hint. */
  info?: ReactNode;
  right?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Panel({
  title,
  eyebrow,
  hint,
  info,
  right,
  children,
  className = "",
}: PanelProps) {
  return (
    <section
      className={`rounded-xl border border-white/10 bg-terminal p-4 sm:p-5 ${className}`}
    >
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          {eyebrow && (
            <div className="text-[10px] font-semibold uppercase tracking-wider text-terminal-ink-muted">
              {eyebrow}
            </div>
          )}
          <h2 className="text-base font-bold tracking-tight text-terminal-ink">
            {title}
          </h2>
          {hint && (
            <p className="mt-0.5 max-w-prose text-[11px] leading-snug text-terminal-ink-muted">
              {hint}
            </p>
          )}
          {info && <div className="mt-1.5">{info}</div>}
        </div>
        {right}
      </div>
      {children}
    </section>
  );
}
